/* D3 — Barra superior dinámica hacia el envío gratis.
   El peldaño a construir es la 2ª camiseta: el progreso hacia el umbral
   tiene que ser visible en todo el sitio, no solo en el carrito. */
(function () {
  if (window.CapponiTicker) return;

  function euros(cents) {
    var v = cents / 100;
    var s = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2).replace('.', ',');
    return s + ' €';
  }

  function render(el, cart) {
    var threshold = parseFloat(el.dataset.threshold || '0') * 100;
    var total = cart ? cart.total_price : 0;

    if (!threshold) return;

    if (!cart || cart.item_count === 0) {
      el.innerHTML = el.dataset.empty;
      return;
    }

    if (total >= threshold) {
      el.innerHTML = el.dataset.unlocked;
      return;
    }

    var remaining = threshold - total;
    var pct = Math.max(0, Math.min(100, Math.round((total / threshold) * 100)));
    var text = el.dataset.progressText.replace('[FALTAN]', euros(remaining));
    el.innerHTML =
      text +
      '<span class="capponi-ticker__progress" aria-hidden="true"><span style="inline-size:' +
      pct +
      '%"></span></span>';
  }

  function refresh() {
    var nodes = document.querySelectorAll('[data-capponi-ticker]');
    if (!nodes.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        nodes.forEach(function (el) {
          render(el, cart);
        });
      })
      .catch(function () {});
  }

  window.CapponiTicker = { refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  ['cart:update', 'cart:refresh', 'variant:update'].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });

  // Red de seguridad: el theme añade al carrito por fetch en varios puntos.
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : url && url.url;
    var p = origFetch.apply(this, arguments);
    if (href && /\/cart\/(add|change|update|clear)/.test(href)) {
      p.then(function () {
        setTimeout(refresh, 60);
      }).catch(function () {});
    }
    return p;
  };
})();
